import React, { useEffect, useRef, useState } from 'react';
import { FaSearch } from 'react-icons/fa';

function SearchInput({
    label,
    value,
    setValue,
    isVisible,
    setVisible
}) {
    const inputRef = useRef(null);
    const [tempValue, setTempValue] = useState(); 
    useEffect(()=>{
        setTempValue(value);
    },[value])
    const handleSearchClick = () => {
        setVisible(!isVisible);
        if (!isVisible) {
            setTimeout(() => {
                inputRef.current?.focus(); 
            }, 0);  
        }
    };

    const handleBlur = () => {
        applySearch();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            applySearch(); // Trigger search and update the value on Enter
        }
    };

    const applySearch = () => {
        // if(tempValue){

            setValue(tempValue); // Update the actual value 
        // }
        // setVisible(false);   // Hide the input
   
    };
    return (
        <>
            <div className="el-table-input">
                <label>{label}</label>
                <div className={`${isVisible ? 'el-searchimg' : ''}`}>
                    <FaSearch onClick={handleSearchClick} />
                </div> </div>
            {isVisible && (
                <input
                    ref={inputRef}
                    type="text"
                    // value={value}
                    value={tempValue}
                    // onChange={(e) => setValue(e.target.value)}
                    onChange={(e) => setTempValue(e.target.value)} 
                    placeholder={`Search by ${label}`}
                    style={{ marginLeft: "5px" }}
                    onBlur={handleBlur} 
                    onKeyDown={handleKeyDown}  
                />
            )}  </>
    );
}

export default SearchInput;
